import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Components/Navbar";
import AllPages from "./AllPages";
import About from "./Pages/about";
import Footer from "./Components/Footer";
import Footer2 from "./Components/Footer2";
import Aos from "aos";
import "aos/dist/aos.css";
import Contact from "./Pages/Contact2";
import { ColorRing } from "react-loader-spinner";
import Services from "./Pages/Services";
import Projects from "./Pages/Projects";

function App() {
  const [showOnTop, setShowOnTop] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  // Retrieve theme mode preference from local storage or default to false (light mode)
  const initialDarkMode = localStorage.getItem("darkMode") === "true";
  const [darkMode, setDarkMode] = useState(initialDarkMode);

  const toggleMode = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    // Update local storage with the new mode
    localStorage.setItem("darkMode", newMode.toString());
  };

  useEffect(() => {
    Aos.init({
      duration: 500,
      once: true,
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setShowOnTop(scrollPosition > 200); // Show button after scrolling down 200px
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    // Show loading spinner on window load
    document.body.style.overflow = "hidden";
      setLoading(true);

    // Hide loading spinner when content has loaded
    window.addEventListener("load", () => {
      setLoading(false);
    });
    // Disable scrolling
    // setLoading(true); // Set loading to true on route change

    // Simulate a delay to test the loader spinner
    setTimeout(() => {
      setLoading(false); // After 3 seconds, set loading to false to hide the loader spinner
      // Enable scrolling after loading is completea
      document.body.style.overflow = "auto";
    }, 250);
  }, [location.pathname]); // Trigger effect on route change

  // Scroll to the top of the page when the location changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Redirect to home page on refresh
  useEffect(() => {
    if (performance.navigation.type === 1) {
      // Page is being refreshed
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (darkMode) {
      root.classList.add("sunMode");
    } else {
      root.classList.remove("sunMode");
    }
  }, [darkMode]);

  return (
    <div className="App">
      {loading && (
        <div className="vortex-wrapper fixed top-0 left-0">
          <ColorRing
            visible={true}
            height="80"
            width="80"
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperclassName="color-ring-wrapper"
            colors={
              darkMode
                ? ["#3B3B98", "#3B3B98", "#3B3B98", "#3B3B98", "#3B3B98"]
                : ["#7efff5", "#7efff5", "#7efff5", "#7efff5", "#7efff5"]
            }
          />
        </div>
      )}

      {showOnTop && (
        <div className="OnTop animate-bounce fixed bottom-7 right-7 text-2xl md:bottom-10 md:right-16 md:text-3xl rounded">
          <a href="#Home">
            <i className="bx bx-up-arrow-alt"></i>
          </a>
        </div>
      )}
      <Navbar darkMode={darkMode} toggleMode={toggleMode} />
      <Routes>
        <Route path="/" element={<AllPages />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      {location.pathname === "/about" || location.pathname === "/skills" ? (
        <Footer2 />
      ) : (
        <Footer />
      )}
    </div>
  );
}

export default App;
